import React from 'react'

interface ColumnsDeviderProps {
  label: string;
  isRequired?: boolean;
  children: React.ReactNode;
}

const ColumnsDevider: React.FC<ColumnsDeviderProps> = ({ label, isRequired, children }) => {
  return (
    <div className="col-lg-6 col-sm-6 pb-2">
      <div className="row">
        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
          <label htmlFor={label.replace(/\s+/g, "_")} className={`col-form-label ${isRequired && 'required'} `}>{label}</label>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ColumnsDevider